import OperationalReportPage from './OperationalReportPage';
export default function ReorderStockCoverReportPage(){return <OperationalReportPage kind="reorder-stock-cover"/>;}
